import { memo } from 'react';
import PlaceOrderContent from './PlaceOrderContent';

const PlaceOrder = ({ arrPlaceOrderInfo, activeTabKey , isHeader }) => {

    return (
        <>        
            <PlaceOrderContent arrPlaceOrderInfo={arrPlaceOrderInfo} activeTabKey={activeTabKey} isHeader={isHeader}/>    
        </>  
    );
};

export default memo(PlaceOrder);